import { IErrorData, IErrorDataAction } from 'models/error';
import { browserHistory } from 'react-router';

/** Action Types */
export const SET_ERROR_MESSAGE: string = 'error/SET_ERROR_MESSAGE';
export const RESET_ERROR_MESSAGE: string = 'error/RESET_ERROR_MESSAGE';

/** Initial State */
const initialState: IErrorData = {
	message: null,
};

/** Reducer */
export function errorReducer(state = initialState, action: IErrorDataAction) {
	switch (action.type) {
		case SET_ERROR_MESSAGE:
			return Object.assign({}, state, {
				message: action.payload.message,
			});

		case RESET_ERROR_MESSAGE:
			return Object.assign({}, state, {
				message: null,
			});

		default:
			return state;
	}
}

export function goToErrorPage(message: any) {
	return (dispatch) => {
		dispatch(setErrorMessage(message));
		browserHistory.push('/error');
	};
}

export function setErrorMessage(message: any): IErrorDataAction {
	return {
		type: SET_ERROR_MESSAGE,
		payload: {
			message,
		},
	};
}

export function resetErrorMessage(): IErrorDataAction {
	return {
		type: RESET_ERROR_MESSAGE,
	};
}
